<template>
  <div
    class="spring-spinner"
    style="margin-top: 12px"
    v-if="!thereIsNoOrders && !errorMessage && !orders.length"
  >
    <div class="spring-spinner-part top">
      <div class="spring-spinner-rotator"></div>
    </div>
    <div class="spring-spinner-part bottom">
      <div class="spring-spinner-rotator"></div>
    </div>
  </div>
  <div class="tab-container" @scroll="scroll($event)" v-else-if="orders.length">
    <order-card
      v-for="(item, index) in orders"
      :key="index"
      :initData="item"
      @cancelled="orders.splice(index, 1)"
    />
    <div class="spring-spinner" v-if="loading">
      <div class="spring-spinner-part top">
        <div class="spring-spinner-rotator"></div>
      </div>
      <div class="spring-spinner-part bottom">
        <div class="spring-spinner-rotator"></div>
      </div>
    </div>
  </div>
  <div
    class="w-full h-full float-left flex items-center justify-center"
    v-if="errorMessage"
  >
    <p class="w-full text-center mb-16 text-gray">{{ errorMessage }}</p>
  </div>
  <div
    class="w-full h-full float-left flex items-center justify-center"
    v-else-if="thereIsNoOrders"
  >
    <p class="w-full text-center mb-16 text-gray">{{ $t('gnenral.no_orders') }}</p>
  </div>
</template>

<script>
import OrderCard from "@/components/OrderCard.vue";
import socketEventsMixin from "@/mixins/socketEventsMixin";

export default {
  name: "ReservationOrders",
  mixins: [socketEventsMixin],
  events() {
    return {
      "Passengers:booking_updated": this.changeOrderStatus,
    };
  },
  components: {
    OrderCard,
  },
  data() {
    return {
      thereIsNoOrders: false,
      orders: [],
      errorMessage: "",
      page: 1,
      lastPage: 0,
      loading: false,
    };
  },
  created() {
    if (!this.orders.length) {
      this.$store
        .dispatch("getOrders", "RESERVATION")
        .then((response) => {
          if (response.data.length) {
            this.thereIsNoOrders = false;
            this.lastPage = response.last_page;
            response.data.forEach((el) => {
              this.orders.push(el);
            });
          } else {
            this.thereIsNoOrders = true;
          }
        })
        .catch((error) => {
          this.errorMessage = error;
        });
    }
  },
  methods: {
    addToOrders(order) {
      if (order && order.now == "0")
        if (this.orders.length > 0)
          for (let i = 0; i < this.orders.length; i++) {
            if (this.orders[i].status === "PENDING") {
              this.orders.splice(i, 0, order);
              break;
            }
          }
        else this.orders.push(order);
    },
    loadData(page) {
      this.$store
        .dispatch("getOrdersPageData", { page: page, time: "RESERVATION" })
        .then((response) => {
          response.forEach((el) => {
            this.orders.push(el);
          });
        })
        .catch((error) => {
          this.errorMessage = error;
        })
        .finally(() => {
          this.loading = false;
          this.page++;
        });
    },
    scroll(event) {
      if (
        Math.round(event.target.scrollTop + event.target.offsetHeight) ==
          event.target.scrollHeight &&
        this.page < this.lastPage &&
        !this.loading
      ) {
        this.loading = true;
        this.loadData(this.page + 1);
      }
    },
    findBookingById(id) {
      for (let i = 0; i < this.orders.length; i++) {
        if (this.orders[i].id == id) return i;
        break;
      }
    },
    changeOrderStatus({ booking_id, status, driver }) {
      let index = this.findBookingById(booking_id);
      if (this.orders[index]) {
        if (status == "DONE" || status == "PAID") {
          this.orders.splice(index, 1);
          if (this.orders.length <= 0) this.thereIsNoOrders = true;
        } else if (driver) {
          this.orders[index].status = status;
          this.orders[index]["captain_name"] = driver.first_name;
          this.orders[index]["taxi_number"] = driver.username;
          this.orders[index]["captain_phone_number"] = driver.phone_number;
          this.orders[index]["car_brand_model"] = driver.car_brand_model;
          this.orders[index]["car_brand"] = driver.car_brand;
          this.orders[index]["car_color"] = driver.car_color;
          this.orders[index]["car_plate_number"] = driver.car_plate_number;
        } else this.orders[index].status = status;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.tab-container {
  width: 100%;
  height: 100%;
  float: left;
  overflow-y: overlay;
  padding: 22px 18px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.tab-container::-webkit-scrollbar {
  width: 0.2em;
}

.tab-container::-webkit-scrollbar-track {
  background-color: transparent;
}

.tab-container::-webkit-scrollbar-thumb {
  background-color: #c1c5d8;
  border-radius: 9999px;
}
</style>
